import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

// Custom hover tooltip, portalled to <body> so panel overflow can't clip it
// and clamped to the viewport so it never runs off an edge. Desktop pointers
// only; flips below the target when there is no room above.
export default function Tip({ tip, className, style, as: As = 'div', children }) {
  const [pos, setPos] = useState(null);
  const ref = useRef(null);
  const tipRef = useRef(null);
  const hoverable = typeof window !== 'undefined' && window.matchMedia('(hover: hover)').matches;

  useLayoutEffect(() => {
    if (!pos || pos.measured || !tipRef.current || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    const t = tipRef.current.getBoundingClientRect();
    let left = r.left + r.width / 2 - t.width / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - t.width - 8));
    let top = r.top - t.height - 6;
    if (top < 8) top = r.bottom + 6;
    setPos({ top, left, measured: true });
  }, [pos]);

  useEffect(() => {
    if (!pos) return;
    const hide = () => setPos(null);
    window.addEventListener('scroll', hide, true);
    return () => window.removeEventListener('scroll', hide, true);
  }, [pos]);

  return (
    <As
      ref={ref}
      className={className}
      style={style}
      onMouseEnter={hoverable ? () => setPos({ top: 0, left: -9999 }) : undefined}
      onMouseLeave={() => setPos(null)}
    >
      {children}
      {pos && createPortal(
        <div
          ref={tipRef}
          className="app-tip"
          style={{ top: pos.top, left: pos.left, visibility: pos.measured ? 'visible' : 'hidden' }}
        >{tip}</div>,
        document.body
      )}
    </As>
  );
}
